module.exports = __webpack_public_path__ + "static/img/lijiang.58590a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lijiang.jpg
// module id = 3nS2
// module chunks = 1